(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AmcImportController", AmcImportController);

    AmcImportController.$inject = ["AmcUpload","$state","$timeout"];
    function AmcImportController(AmcUpload,$state,$timeout) {

        var vm = this;
		var formData,getFile;
		
          $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx)$/;
		  vm.upload = function () {

            getFile = document.getElementById('uploadfile').files[0];
            formData = new FormData();
            formData.append("file", getFile);
            
            AmcUpload.amcupload(formData, function (response) {
                if (response.status === 200) {
		            $timeout(function () {
		                $state.go("asset");
		            }, 200);
		        }
            });
        };
    }
})();
